// extracted by mini-css-extract-plugin
export default {"line":"PaymentDetailsModal_line__O8HwY"};